// Registers /sw.js (offline shell + web push). A new version activates on the
// next navigation; the old Timepeak service worker is replaced at the same URL.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
